<template>
  <div>
    <Head title="របាយការណ៍យឺត" />
    <h1 class="moul flex items-center mb-8 text-2xl">
      <Link class="flex items-center" href="/reports"><CurrencyDollarIcon class="mr-2 w-8 h-8" /> បិទបញ្ជីរ៖ {{ formattedDate(this.start_date) }} - {{ formattedDate(this.end_date) }}</Link>
    </h1>
    <div class="noprint flex items-center justify-between">
      <div class="flex w-full">
        <text-input @change="handleSearch" v-model="form.start_date" :error="errors.start_date" type="date" class="pb-8 pr-6 w-full lg:w-1/4" label="ថ្ងៃចាប់ផ្តើម *" />
        <text-input @change="handleSearch" v-model="form.end_date" :error="errors.end_date" type="date" class="pb-8 pr-6 w-full lg:w-1/4" label="ថ្ងៃចាប់បញ្ចប់ *" />
      </div>

      <button class="flex items-center mb-2 px-4 py-2 hover:text-indigo-500 text-white hover:bg-green-300 bg-green-500 rounded-md" tabindex="-1" type="button" @click="print"><PrinterIcon class="mr-1 w-5 h-5" />បោះពុម្ភ</button>
    </div>
    <div class="schedule p-2 bg-white">
      <div class="schedule mb-10">
        <h2 class="py-2 text-red-600 text-xl font-medium">កំណត់ត្រាបង់ប្រាក់</h2>
        <table class="table w-full whitespace-nowrap">
          <tr class="text-left font-medium">
            <td class="p-1 text-center border border-black">កាលបរិច្ឆេទដែលបានបង់</td>
            <td class="p-1 text-center border border-black">ឈ្មោះអតិថិជន</td>
            <td class="p-1 text-center border border-black">ប្រាក់ដើមត្រូវប្រមូល</td>
            <td class="p-1 text-center border border-black">ការប្រាក់ត្រូវប្រមូល</td>
            <td class="p-1 text-center border border-black">សេវារដ្ឋបាល</td>
            <td class="p-1 text-center border border-black">ប្រាក់ពិន័យ</td>
            <td class="p-1 text-center text-green-600 font-medium border border-black">សរុបប្រាក់ត្រូវបង់</td>

            <td class="p-1 text-center text-indigo-600 border border-black">ប្រាក់ដែលបានបង់</td>
            <td class="p-1 text-center text-red-600 border border-black">នៅសល់</td>
          </tr>
          <tr v-for="(schedule, s) in schedules" :key="s" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="p-1 border border-black">{{ formattedDate(schedule.pay_date) }}</td>
            <td class="p-1 text-center border border-black">{{ schedule.customer_fullname }}</td>
            <td class="p-1 text-right border border-black">{{ formatNumber(schedule.principle_amount) }}</td>
            <td class="p-1 text-right border border-black">{{ formatNumber(schedule.interest) }}</td>
            <td class="p-1 text-right border border-black">{{ formatNumber(schedule.service_fee) }}</td>
            <td class="p-1 text-right border border-black">{{ formatNumber(schedule.paid_penalty) }}</td>
            <td class="p-1 text-right text-green-600 font-bold border border-black">{{ formatNumber(schedule.total_to_pay) }}</td>
            <td class="p-1 text-right text-indigo-600 font-bold border border-black">{{ formatNumber(schedule.paid_amount) }}</td>
            <td class="p-1 text-right text-red-600 font-bold border border-black">{{ formatNumber(schedule.amount_due) }}</td>
          </tr>

          <tr class="text-left font-bold bg-green-100">
            <td class="p-1 text-right text-indigo-600 border border-black" colspan="2">សរុប</td>
            <td class="p-1 text-right text-red-600 border border-black">{{ formatNumber(total_principal_to_pay) }}</td>
            <td class="p-1 text-right text-red-600 border border-black">{{ formatNumber(total_interest) }}</td>
            <td class="p-1 text-right text-red-600 border border-black">{{ formatNumber(total_service_fee) }}</td>
            <td class="p-1 text-right text-red-600 border border-black">{{ formatNumber(total_penalty) }}</td>
            <td class="p-1 text-right text-red-600 border border-black">{{ formatNumber(total_to_pay) }}</td>
            <td class="p-1 text-right text-red-600 border border-black">{{ formatNumber(total_paid) }}</td>
            <td class="p-1 text-right text-red-600 border border-black">{{ formatNumber(toal_amount_due) }}</td>
          </tr>
        </table>
      </div>
      <div class="pt-10 text-center">
        <h1 class="moul">ទឹកប្រាក់ដែលគួរទទួលបាន</h1>
        <div class="flex items-center justify-center">
          <input type="text" v-model="form.received_amount" class="px-4 py-2 text-2xl border focus:border-blue-500 border-gray-300 rounded-md focus:outline-none focus:ring" />
          <a class="btn-indigo ml-2" href="/reports/late">យល់ព្រម</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import { CurrencyDollarIcon, PrinterIcon } from '@heroicons/vue/24/outline'
import { formattedDate, formatNumber, formatTwoDigits } from '@/helper'
import SelectInput from '@/Shared/SelectInput'
import TextInput from '@/Shared/TextInput'

export default {
  components: {
    Head,
    CurrencyDollarIcon,
    PrinterIcon,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  props: {
    schedules: Object,
    total_principal_to_pay: Number,
    total_interest: Number,
    total_service_fee: Number,
    total_penalty: Number,
    total_to_pay: Number,
    total_paid: Number,
    toal_amount_due: Number,
    start_date: Date,
    end_date: Date,
    errors: Object,
  },
  methods: {
    formattedDate,
    formatNumber,
    formatTwoDigits,
    print() {
      var style = document.createElement('style')
      style.appendChild(document.createTextNode('@media print { @page { size: landscape; } html, body{margin:0!important; padding:0!important;} }'))
      document.head.appendChild(style)
      window.print()
    },
    handleSearch(e) {
      e.preventDefault()
      this.form.get('/reports/closeout')
    },
  },
  remember: 'form',
  data() {
    return {
      schedules: this.schedules,
      total_principal_to_pay: this.total_principal_to_pay,
      total_interest: this.total_interest,
      total_service_fee: this.total_service_fee,
      total_penalty: this.total_penalty,
      total_to_pay: this.total_to_pay,
      total_paid: this.total_paid,
      toal_amount_due: this.toal_amount_due,
      start_date: this.start_date,
      end_date: this.end_date,
      form: this.$inertia.form({
        start_date: this.start_date,
        end_date: this.end_date,
        received_amount: formatTwoDigits(this.total_paid),
      }),
    }
  },
}
</script>
